import { IPlayerState } from 'State/Player/IPlayerState';
import { IGameState } from '../Game/IGameState';

export default class TimerStateHelper {
    public static setTimer(
        state: IGameState,
        timerType: string,
        time: Date
    ): IGameState {
        const timers: Map<string, Date> = new Map<string, Date>(
            state.playerState.timers
        );
        timers.set(timerType, time);
        return {
            ...state,
            playerState: this.setPlayerStateTimer(state.playerState, timerType, time)
        };
    }

    public static setPlayerStateTimer(
        state: IPlayerState,
        timerType: string,
        time: Date
    ): IPlayerState {
        const timers: Map<string, Date> = new Map<string, Date>(
            state.timers
        );
        timers.set(timerType, time);
        return {
            ...state,
            timers
        };
    }
}
